<template>
  <div class="p-d-flex p-jc-center p-ai-center h100">
    <slot/>
  </div>
</template>
